"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapToInternal = mapToInternal;
require("core-js/modules/web.dom.iterable");
/**
 * Excelの行データ（ヘッダー名キー）を内部名キーに変換する。
 *
 * @param {Object} rawRow - Excelヘッダー名をキーとする1行分のデータ
 * @param {Object} format - フォーマット定義（fields配列を持つ）
 * @returns {Object} 内部名をキーとするデータ
 */
function mapToInternal(rawRow, format) {
  var result = {};
  format.fields.forEach(function (field) {
    var val = rawRow[field.header];
    if (field.parse && val !== undefined && val !== null) {
      val = field.parse(val);
    }
    result[field.internalName] = val;
  });
  return result;
}